import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'hooks/queries/query-keys';

import { IWorldNftEvent } from '../types/world-nft-event.types';
import mock from './mock';

type UseWorldNftEventInput = {
  eventId: string;
};

type UseWorldNftEventOutput = {
  event: IWorldNftEvent | null;
  loading: boolean;
  error: Error | null;
};

export const useWorldNftEvent = (input: UseWorldNftEventInput): UseWorldNftEventOutput => {
  const { eventId } = input;

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.event.detail(eventId),
    queryFn: async () => {
      // 1 second delay for loading state
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const eventKey = `api/event/${eventId}`;
      return mock[eventKey] || null;
    },
    enabled: !!eventId,
  });

  return {
    event: data || null,
    loading: isLoading,
    error,
  };
};
